/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import MobileAppChecker from '../services/utils/mobile_app_checker';

export default class AccountFree extends React.Component {

  render() {
    return(
      <div className='user-subscription sidebar'>
        <b>Free for One Plan</b>
        <p>$0.00</p>
        { this.renderUpgrade() }
      </div>
    );
  }

  renderUpgrade() {
    if (MobileAppChecker.isMobileApp()) {
      if (process.env.REACT_APP_MOBILE_SUBSCRIPTION_UPGRADE_ENABLED === 'false') {
        return null
      }
    }
    return <Link to='/plans'>Go Unlimited</Link>;
  }
}



// WEBPACK FOOTER //
// ./src/components/account_free.jsx